export { AccordionPanelComponent } from './accordion-group.component';
export { AccordionComponent } from './accordion.component';
export { AccordionModule } from './accordion.module';
export { AccordionConfig } from './accordion.config';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/ng2-bootstrap/src/accordion/index.ts